<template>
  <ul :class="`select-area ${error ? 'is-error' : ''}`">
    <li>
      <select name="year"
              :value="values.year"
              @change="onChangeValue('year', $event)"
              @blur="validateDate('year')"
      >
        <option value="">--</option>
        <option v-for="year in listYear" :key="year" :value="year">
          {{ year }}
        </option>
      </select>
    </li>
    <li>
      <select name="month"
              :value="values.month"
              @change="onChangeValue('month', $event)"
              @blur="validateDate('month')"
      >
        <option value="">--</option>
        <option v-for="month in listMonth" :key="month" :value="month">
          {{ month }}
        </option>
      </select>
    </li>
    <li>
      <select name="day"
              :value="values.date"
              @change="onChangeValue('date', $event)"
              @blur="validateDate('date')"
      >
        <option value="">--</option>
        <option v-for="date in listDate" :key="date" :value="date">
          {{ date }}
        </option>
      </select>
    </li>
  </ul>
</template>

<script>
  import { getYearsLabel, getMonthsLabel, getDatesLabel } from '../../constant/getTimes'
  import { validateRequired } from '../../helpers/schemaValidate'
  import { DATE_INVALID } from '../../constant/text'

  export default {
    name: 'DateSelect',
    props: {
      error: {
        type: String,
        default: '',
      },
      values: {
        type: Object,
        default: () => {
          return {
            year: '',
            month: '',
            date: '',
          }
        },
      },
    },
    data() {
      return {
        listYear: getYearsLabel(),
        listMonth: getMonthsLabel(),
        listDate: getDatesLabel(),
        listDateDefault: getDatesLabel(),
      }
    },
    watch: {
      'values.month': {
        handler(val) {
          const dateDefault = [...this.listDateDefault]

          if (val === '2') {
            if (parseInt(this.values.year) % 4 === 0 && parseInt(this.values.year) % 100 !== 0) {
              this.listDate = dateDefault.slice(0, dateDefault.length - 3)
            } else {
              this.listDate = dateDefault.slice(0, dateDefault.length - 2)
            }
            return
          }

          if (val && ['4', '6', '9', '11'].indexOf(val) !== -1) {
            this.listDate = dateDefault.slice(0, dateDefault.length - 1)
          } else {
            this.listDate = dateDefault
          }
        },
        deep: true,
      },
      'values.year': {
        handler(newVal) {
          const dateDefault = [...this.listDateDefault]

          if (this.values.month === '2') {
            if (parseInt(newVal) % 4 === 0 && parseInt(newVal) % 100 !== 0) {
              this.listDate = dateDefault.slice(0, dateDefault.length - 2)
            } else {
              this.listDate = dateDefault.slice(0, dateDefault.length - 3)
            }
          }
        },
        deep: true,
      },

    },
    methods: {
      onChangeValue(field, e) {
        const { target: { value } } = e
        this.$emit('onHandleChange', field, value)
      },
      validateDate(field) {
        switch (field) {
          case 'year':
            validateRequired('year', DATE_INVALID)
              .validateAt('year', this.values)
              .then(() => {
                this.$emit('onValidate', 'date', '')
              })
              .catch(error => {
                this.$emit('onValidate', 'date', error.message)
              })
            break

          case 'month':
            validateRequired('month', DATE_INVALID)
              .validateAt('month', this.values)
              .then(() => {
                this.$emit('onValidate', 'date', '')
              })
              .catch(error => {
                this.$emit('onValidate', 'date', error.message)
              })
            break

          default:
            validateRequired('date', DATE_INVALID)
              .validateAt('date', this.values)
              .then(() => {
                this.$emit('onValidate', 'date', '')
              })
              .catch(error => {
                this.$emit('onValidate', 'date', error.message)
              })
            break
        }

      },
    },
  }
</script>

<style scoped>

</style>
